import { render, staticRenderFns } from "./nuevaFacturacion.vue?vue&type=template&id=3ce95c5e&"
import script from "./nuevaFacturacion.vue?vue&type=script&lang=js&"
export * from "./nuevaFacturacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports